/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import AppointmentActions from 'DesignSystem/AppointmentActions/index'
import PatientCommsContactMethods from 'DesignSystem/PatientComms/PatientCommsContactMethods/index'
import ProfileActions from 'DesignSystem/ProfileActions/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/ActionsDialog/Content",
  update
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let eventAppointmentPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.patient._id',
})
let eventAppointmentPatientPersonValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.patient.person',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let eventIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'id',
})
let eventVaxiomIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'vaxiom_id',
})
let eventStateValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let eventConfirmationStatusValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'confirmation_status',
})
let eventStartValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'start',
})
let eventEndValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'end',
})
let eventVaxiomLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'vaxiom_location_id',
})
let eventLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'location_id',
})
let eventLocationNameValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'location_name',
})
let eventAssistantIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'assistant.id',
})
let eventProviderIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'provider.id',
})
let eventChairIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'chair_id',
})
let eventAppointmentIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment._id',
})
let eventAppointmentHasNotesValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.has_notes',
})
let eventAppointmentPatientIdValueData1 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.patient._id',
})
let timegridTimeZoneIdValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'time_zone_id',
})
let onClickComplete = fromHelpers.useOnClickComplete({
  children,
  viewPath,
  update
  
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  update
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-3-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-5-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 weight="medium"
 color={dtColorsNeutral500}
 text="Visit"
/>
<ProfileActions
  viewPath={`${viewPath}/ProfileActions`}
 data="event.appointment.patient._id"
 patient_id={eventAppointmentPatientIdValueData}
 data="event.appointment.patient.person"
 person={eventAppointmentPatientPersonValueData}
 color={dtColorsNeutral900}
/>
</div>
</div>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 style={{'--pl-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-3-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-5-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Appointment Actions"
 color={dtColorsNeutral400}
 weight="medium"
 size="normal"
/>
</div>
<AppointmentActions
  viewPath={`${viewPath}/AppointmentActions`}
 data="event.id"
 appointment_booking_id={eventIdValueData}
 data="event.vaxiom_id"
 appointment_booking_vaxiom_id={eventVaxiomIdValueData}
 data="event.state"
 appointment_booking_state={eventStateValueData}
 data="event.confirmation_status"
 appointment_booking_confirmation_status={eventConfirmationStatusValueData}
 data="event.start"
 appointment_booking_start={eventStartValueData}
 data="event.end"
 appointment_booking_end={eventEndValueData}
 data="event.vaxiom_location_id"
 appointment_booking_vaxiom_location_id={eventVaxiomLocationIdValueData}
 data="event.location_id"
 appointment_booking_location_id={eventLocationIdValueData}
 data="event.location_name"
 appointment_booking_location_name={eventLocationNameValueData}
 data="event.assistant.id"
 appointment_booking_assistant_id={eventAssistantIdValueData}
 data="event.provider.id"
 appointment_booking_provider_id={eventProviderIdValueData}
 data="event.chair_id"
 appointment_booking_chair_id={eventChairIdValueData}
 data="event.appointment._id"
 appointment_id={eventAppointmentIdValueData}
 data="event.appointment.has_notes"
 appointment_has_notes={eventAppointmentHasNotesValueData}
 data="event.appointment.patient._id"
 patient_id={eventAppointmentPatientIdValueData1}
 onClickComplete={onClickComplete}
 data="timegrid.time_zone_id"
 time_zone_id={timegridTimeZoneIdValueData}
/>
<div
  data-testid="Content.Vertical:3"
  data-view-path={viewPath}
 style={{'--pl-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-3-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-5-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical3}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Comms"
 color={dtColorsNeutral400}
 weight="medium"
 size="normal"
/>
</div>
<PatientCommsContactMethods
  viewPath={`${viewPath}/PatientCommsContactMethods`}
 update={update}
 onChange={onChange}
/>
</div>
{children}
</React.Fragment>)
}